import React, { Dispatch, DispatchWithoutAction } from 'react';

import {
	CheckoutOrderFragment,
	OrderAdditionalServiceGdsServiceServiceType,
	GdsServicesWithPurchasePredictionsFragment,
	GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment,
	GdsService_OrderAdditionalServiceGdsServiceMeal_Fragment
} from '@websky/graphql';
import { ServicePayload } from '../../../Checkout/store/selectedServices/actions';
import { SelectedService } from '../../types';

import AiPurchasePredictionMeal from '../AiPurchasePredictionMeal/AiPurchasePredictionMeal';
import AiPurchasePredictionBaggage from '../AiPurchasePredictionBaggage/AiPurchasePredictionBaggage';

export interface Props {
	order: CheckoutOrderFragment;
	service: GdsServicesWithPurchasePredictionsFragment;
	onChange: Dispatch<SelectedService>;
	onAgree: Dispatch<ServicePayload>;
	onDisagree: DispatchWithoutAction;
}

const AiPurchasePredictionItem: React.FC<Props> = ({ order, service, onChange, onDisagree, onAgree }) => {
	const onAgreeAddServiceToOrder = (service: GdsServicesWithPurchasePredictionsFragment) => {
		const segments: string[] = [];

		service.allowedSegments.forEach(segment => {
			segment.forEach(subSegment => {
				segments.push(subSegment);
			});
		});

		onAgree({
			passengerId: service.allowedPassengers[0][0],
			segmentId: service.allowedSegments[0][0],
			allowedSegments: service.allowedSegments,
			segmentIds: segments,
			serviceId: service.id,
			service: {
				id: service.id,
				type: service.type,
				price: service.price
			}
		});
	};

	if (service.type === OrderAdditionalServiceGdsServiceServiceType.Meal) {
		const meal = service as GdsService_OrderAdditionalServiceGdsServiceMeal_Fragment;

		return (
			<AiPurchasePredictionMeal
				order={order}
				meal={meal}
				onDisagree={onDisagree}
				onChange={() => onChange({ type: meal.type })}
				onAgree={() => onAgreeAddServiceToOrder(meal)}
			/>
		);
	}

	if (service.type === OrderAdditionalServiceGdsServiceServiceType.Baggage) {
		const baggage = service as GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment;

		return (
			<AiPurchasePredictionBaggage
				item={baggage}
				onDisagree={onDisagree}
				onChange={() => onChange({ type: baggage.type, subType: baggage.baggageType })}
				onAgree={() => onAgreeAddServiceToOrder(baggage)}
			/>
		);
	}

	return <></>;
};

export default AiPurchasePredictionItem;
